import clsx from 'clsx';
import { ReactNode } from 'react';

export const wrapperIconByStatus = (icon: ReactNode, statusClassName?: string) => {
  if (!statusClassName) return icon;

  return (
    <div className="relative h-fit w-fit">
      {icon}
      <span
        className={clsx('absolute -bottom-0.5 -right-1 h-1.5 w-1.5 rounded-full', statusClassName)}
      />
    </div>
  );
};
